export default __webpack_public_path__ + "static/media/afp-habitat-white.c609d6ff.svg";